module.exports = __webpack_public_path__ + "static/media/prescription.2c6ec560.svg";